import styled from "styled-components";
export const FormWrapper = styled.div`
  color: #2f3335;
  margin: 10% 0%;
  .note {
    color: #767676;
    text-align: start;
    margin-left: 8px;
    margin-top: -12px;
    font-size: 1rem;
  }
  > img {
    margin-bottom: 20px;
  }
  > div {
    width: 100%;
  }

  svg[data-testid="SquareIcon"] {
    fill: white;
    background: white;
  }
  svg[data-testid="CheckIcon"] {
    fill: black;
    background: white;
  }

  .MuiInputLabel-root,
  .MuiTypography-root {
    font-size: 1rem;
    font-weight: normal;
    color: #2f3335;
  }
  .MuiFormControl-root {
    width: 100%;
    border-radius: 0px;
  }
  .MuiOutlinedInput-root {
    width: 100%;
    height: 2.6rem;
  }
  .MuiOutlinedInput-root,
  .MuiOutlinedInput-input,
  .submit_btn {
    border-radius: 0;
  }

  .form-row .MuiSvgIcon-root {
    color: #bfbfc1;
  }
  .MuiButton-root {
    background: #2f3335;
    box-shadow: none;
  }
  .MuiNativeSelect-root {
    background-color: #fff;
    width: 100%;
    height: 2.6rem;
    border: 1px solid rgba(0, 0, 0, 0.12);
    color: #b8b7ba;

    .MuiNativeSelect-select {
      padding: 0 1rem;
    }

    :before {
      border: 0;
    }
  }

  .MuiNativeSelect-root.Mui-error {
    border: 1px solid #d32f2f;
    :after {
      border: 0;
    }
  }

  fieldset {
    border: 0px;
  }
  .form_input {
    .MuiInputBase-input {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 0 1rem;
      border: none;
      outline: none;
      font-size: 0.93rem;
      color: black;
      border-radius: 0;
      background: #fff;
    }
  }

  .MuiInputLabel-root {
    text-align: left;
  }

  .form {
    margin: 5% 10% 2rem 10%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .form-row.year {
    > div:first-child {
      width: 36%;
    }
    > div:nth-child(2),
    > div:nth-child(3) {
      width: 28%;
      .dot {
        display: none;
      }
      label {
        visibility: hidden;
      }
    }
  }

  .form-row.gender {
    margin-bottom: 0.5rem;
    > div {
      display: flex;
      align-items: center;
    }
    .MuiFormGroup-root {
      display: block;
      margin-left: 5px;
    }
  }

  .form-row.name {
    margin-bottom: 0.5rem;
    > div:first-child {
      width: 36%;
    }
    > div:nth-child(2) {
      width: 60%;
    }
  }

  .form-row.phone {
    > div:first-child {
      width: 64%;
    }
    > div:nth-child(2) {
      width: 32%;
      label {
        visibility: hidden;
      }
    }
  }

  .code_btn {
    border-radius: 0;
    width: 100%;
    height: 2.6rem;
    margin-top: 0.2rem;
    line-height: 2.8rem;
    text-align: center;
    background: #2f3335;
    color: #fff;
    font-size: 0.85rem;
  }

  .submit_btn {
    width: 63vw;
    text-align: center;
    color: #fff;
    padding: 1rem 0;
    background: #2f3335;
    margin: 0 auto;
    margin-top: 2.6rem;
    font-size: 1rem;
  }
  .form_timer {
    text-align: left;
    position: relative;
    left: 6px;
    top: -15px;
  }

  .form-row {
    display: flex;
    text-align: start;
    margin-bottom: 1.5rem;
    width: 100%;
    justify-content: space-around;

    > div {
      margin: 0 5px;
      width: 100%;
    }

    > div:last-child {
      margin-right: 0;
    }
    .MuiFormControl-root {
      margin-top: 0.2rem;
    }
    .one-child {
      margin-left: 10px;
    }
  }

  .privacy_content {
    margin-top: 10px;
    margin-left: 8px;
    text-align: left;
    color: rgba(0, 0, 0, 0.6);

    .privacy_check {
      display: flex;
      > div:nth-child(1) {
        display: flex;
        .dot {
          display: none;
        }
        span {
          padding: 0px;
        }
      }
    }

    .border_white {
      content: "";
      width: 10.3vw;
      border-top: 1px solid #fff;
      margin: 5px 0 0.75rem 0;
    }
    .content {
      font-size: 0.93rem;
      line-height: normal;
      margin-bottom: 1.5rem;
    }

    .MuiCheckbox-root {
      .MuiSvgIcon-root {
        > path {
          color: #fff;
        }
      }
    }
  }
  .privacy-btn {
    margin-left: 0.5rem;
    font-size: 1rem;
    text-decoration: underline;
  }
`;

export const PrivacyWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  width: 90%;
  height: 80vh;
  padding: 10px 10px;
  overflow: hidden;
  &:focus {
    outline: none;
  }
  .header {
    float: right;
  }
  .title {
    margin-top: 2rem;
    font-size: 2rem;
    text-align: center;
    &:after,
    &:before {
      content: "";
      display: block;
      width: 10.9vw;
      height: 2px;
      background: #2f3335;
      margin: 1rem auto;
    }
  }
  .content {
    word-break: break-all;
    width: 85%;
    max-height: 65vh;
    margin: 0 auto;
    overflow: auto;
    .detail {
      font-size: 1.2rem;
      margin-bottom: 1rem;
    }
  }
`;

export const formCheckboxIconStyle = {
  width: "22px",
  height: "22px",
  marginRight: "10px",
  paddingTop: "1px",
};

export const ErrorModalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ebebeb;
  width: 65%;
  padding: 40px;
  &:focus {
    outline: none;
  }

  .content {
    height: 100%;
    .content_item {
      letter-spacing: 2px;
      margin: 5px 0;
      font-size: 1.2rem;
      text-align: start;
      font-weight: 300;
    }

    .close_btn {
      border-radius: 0px;
      width: 100%;
      text-align: center;
      color: #fff;
      padding: 1rem 0;
      background: #2f3335;
      margin: 0 auto;
      margin-top: 1.6rem;
      font-size: 1rem;
    }
  }
`;
